import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import AttachedFilesBox from '../Shared/AttachedFilesBox'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import ModalAddFile from '../Shared/ModalAddFile'

import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'

import {
    addFile,
    removeFiles,
    updateInputs,
    getDocumento,
} from '../../actions/documentos'

import {
    getSolicitud
} from '../../actions/solicitudservicioot'

import { isAllowedToViewComponent } from '../../utils/helpers'

class General extends Component {
	render() {

        const { documento, enums } = this.props
        if (!documento) return null
        if (!documento.get('detalles')) return null

		return (
            <div>


                {
                    (documento.get('estado') < 11 && isAllowedToViewComponent('responsable_compras', documento.get('solicitude'))) && (
                        <Fragment>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info">
                                    Adjunte el documento firmado para cerrar esta solicitud haciendo click en el botón <FontAwesome name="cloud-upload" />
                                    </div>                    
                                </div>
                            </div>
                            <div className="separator" />
                        </Fragment>
                    ) 
                }

                
                
                <BoxSection title="Información básica">

                
                    <div className="row">
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Tipo de documento</label>
                                <input type="text" value={ enums.documentos.tipos[documento.get('tipo')].NOMBRE } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Número</label>
                                <input type="text" value={ documento.get('consecutivo') } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-2 col-md-offset-7">
                            <div className="form-group">
                                <label className="control-label">No. Solicitud</label>
                                <input type="text" value={ documento.getIn(['solicitude', 'id']) } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                    </div>
                    <div className="row">

                        <div className="col-md-5">
                            <div className="form-group">
                                <label className="control-label">Tipo de servicio a desarrollar</label>
                                <input type="text" value={ documento.getIn(['solicitude', 'proyecto_evento']) } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Proveedor</label>
                                <input type="text" value={ documento.getIn(['proveedore','nombre']) } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Inicio del contrato</label>
                                <input type="text" value={ moment(documento.get('fecha_inicio')).format('YYYY-MM-DD') } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Culminación del contrato</label>
                                <input type="text" value={ moment(documento.get('fecha_entrega')).format('YYYY-MM-DD') } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                    </div>

                </BoxSection>

                <div className="separator"></div>

                <AttachedFilesBox
                    files={ documento.get('adjuntos') }
                    root='modalSummary.data'
                    removeFiles = { this.props.removeFiles }
                    updateInputs = { this.props.updateInputs }
                    obj={ documento }
                    check={ 'documento' }
                    disabledAttach={ this.props.disabledAttach || !isAllowedToViewComponent('responsable_compras', documento.get('solicitude')) }
                />
                <ModalAddFile
                    action={ () => this.props.addFile(`/files/${documento.get('solicitud_id')}`, documento.get('id'), [() => this.props.getDocumento(documento.get('id')), () => this.props.getSolicitud(documento.get('solicitud_id'))]) }
                />

                <ModalConfirmarAccion />


            </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        addFile: (url, documentoId, actions) => dispatch(addFile(url, documentoId, actions)),
        removeFiles: () => dispatch(removeFiles()),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        getDocumento: (id) => dispatch(getDocumento(id)),
        getSolicitud: (id) => dispatch(getSolicitud(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(General)


// WEBPACK FOOTER //
// ./src/components/Documentos/Contrato.jsx